import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 940px;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing * 6}px ${({ theme }) => theme.spacing * 8}px;
    margin: ${({ theme }) => theme.spacing * 4}px auto;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    color: ${({ theme }) => theme.colors.blue};
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (max-width: 690px) {
        width: calc(100% - 32px);
        margin: ${({ theme }) => theme.spacing * 4}px auto;
    }
`;

export const Button = styled.button`
    margin-top: 24px;
    width: 220px;
    height: 44px;
    border-radius: 6px;
    outline: none;
    border: none;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
`;
